import React, { useState } from "react";
import SubAssetDetailsPopup from "./SubAssetDetailsPopup";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";

const SubAssetActionButton = ({
  id,
  setEdit,
  setSubAssetId,
  toggleShowAddEditAsset,
  trustId,
  subAsset,
  assetId,
  toggleShowDelete,
  used,
}) => {
  const [showView, setShowView] = useState(false);

  const toggleShowModal = () => {
    setShowView(!showView);
  };
  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"View"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleShowModal}
              icon={faEye}
              size="1x"
              data-toggle="modal"
              data-target="#clientDetail"
            />
          </span>
        </CustomTooltip>
        <span>/</span>
        <CustomTooltip message={"Edit"}>
          <span>
            <FontAwesomeIcon
              icon={faEdit}
              size="1x"
              onClick={() => {
                setEdit(true);
                toggleShowAddEditAsset();
                setSubAssetId(id);
              }}
            />
          </span>
        </CustomTooltip>
        {used ? (
          <></>
        ) : (
          <>
            <span>/</span>
            <CustomTooltip message={"Delete"}>
              <span>
                <FontAwesomeIcon
                  icon={faTrash}
                  size="1x"
                  onClick={() => {
                    setSubAssetId(id);
                    toggleShowDelete();
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )}
      </span>

      {showView && (
        <SubAssetDetailsPopup
          showView={showView}
          subAssetId={id}
          toggleShowModal={toggleShowModal}
          setShowView={setShowView}
          trustId={trustId}
          subAsset={subAsset}
          assetId={assetId}
        />
      )}
    </>
  );
};

export default SubAssetActionButton;
